import * as React from "react";
import { Helmet as ReactHelmet } from "react-helmet";

const Helmet = () => (
  <ReactHelmet>
    <meta charSet="utf-8" />
    <title>Planning poker</title>
    <meta name="description" content={"Scrum Poker as simple as ever"} />
    <meta name="og:description" content={"Scrum Poker as simple as ever"} />
    <meta name="og:title" content={"Planning Poker"} />
    <meta name="og:url" content={"https://poker.gorrion.io/"} />
  </ReactHelmet>
);

export default Helmet;
